import { render, staticRenderFns } from "./IntegrationSettingsTab.vue?vue&type=template&id=60882432&"
import script from "./IntegrationSettingsTab.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports